import { Col, ConfigProvider, Row, Skeleton } from 'antd';

interface LedgerFormSkeletonProps {
  loading?: boolean;
}

const LedgerFormSkeleton: React.FC<LedgerFormSkeletonProps> = () => {
  const renderSkeletonItem = () => (
    <Skeleton active title={{ width: '100px' }} paragraph={{ rows: 1 }} />
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Skeleton: {
            paragraphLiHeight: 20,
          },
        },
      }}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <Row gutter={24} key={index} style={{ marginBottom: '1rem' }}>
          {[...Array(3)].map((_, colIdx) => (
            <Col xs={24} lg={8} key={colIdx}>
              {renderSkeletonItem()}
            </Col>
          ))}
        </Row>
      ))}

      <div className="tw-absolute tw-bottom-0 tw-right-10">
        <div className="tw-flex tw-gap-4">
          {[...Array(2)].map((_, idx) => (
            <Skeleton
              key={idx}
              active
              title={false}
              paragraph={{ rows: 1, width: '70px' }}
            />
          ))}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default LedgerFormSkeleton;
